<script lang="ts">
  import PhoneInput from "@shared/svelte/Components/PhoneInput.svelte";
  import { HttpPromise } from "@shared/svelte/Modules/ApiService";
  import type { SalesRep } from "@shared/types/SalesRep";
  import Flash from "@shared/services/flashv2.js";

  export let salesRep: SalesRep;
  export let currentUserRole: string;
  export let assigned: boolean;

  let name = salesRep.name;
  let email = salesRep.contact_email;
  let phone = salesRep.contact_phone;
  let role = salesRep.role;
  const canUpdateRole =
    salesRep.role && ["distributor_admin", "payments_admin"].includes(currentUserRole);

  const updateSalesRep = async () => {
    try {
      await HttpPromise({
        method: "PUT",
        url: `/api/distributor/sales_reps/${salesRep.id}`,
        data: {
          sales_rep: {
            name,
            contact_phone: phone,
            role: canUpdateRole ? role : salesRep.role,
          },
        },
      });
      salesRep = { ...salesRep, name, contact_phone: phone, role };
      Flash.now({ type: "success", message: "We have updated the information" });
    } catch (_) {
      Flash.now({ type: "error", message: "There was an error updating the information." });
    }
  };
</script>

<form class="fizz-half-width" on:submit|preventDefault={updateSalesRep}>
  <label class="fizz-label fizz-stack-4" for="name">Name</label>
  <input
    type="text"
    name="name"
    id="name"
    class="fizz-input-text fizz-full-width fizz-stack-12"
    bind:value={name}
  />

  <label class="fizz-label fizz-stack-4" for="email">Email</label>
  <input
    type="email"
    name="email"
    id="email"
    class="fizz-input-text fizz-full-width fizz-stack-12"
    disabled
    bind:value={email}
  />

  <PhoneInput
    bind:value={phone}
    label={"Phone"}
    id="phone"
    extraClasses={"fizz-input fizz-full-width fizz-stack-12"}
  />

  {#if canUpdateRole}
    <label class="fizz-label fizz-stack-4" for="role">Role</label>
    <select
      bind:value={role}
      class="fizz-select fizz-full-width fizz-stack-12"
      name="role"
      id="role_select"
    >
      <option value="distributor_admin">Distributor admin</option>
      <option value="manager">Manager</option>
      <option value="sales_rep">Sales rep</option>
      <option value="payments_admin">Payments admin</option>
    </select>
  {/if}

  <button type="submit" class="fizz-button-secondary submit-profile" disabled={!assigned}
    >Save changes</button
  >
</form>
